import { ColumnSetupType } from "../../../../../../../../../../../../../../storybook/data-grid/utils/types/types";
import { Elc } from "../../../../../../../../../../../../../../services/cloudchipr.api";

export const elcColumns: ColumnSetupType<Elc>[] = [
  {
    accessorKey: "cluster_id",
    header: "Cluster Name",
    type: "identifier",
    size: 220,
    meta: { sticky: "left", hideFromSettings: true },
  },
  {
    accessorKey: "price_per_month",
    header: "Monthly Price",
    type: "money",
  },
  {
    accessorKey: "all_time_spent",
    header: "Total Spend",
    type: "money",
  },
  {
    accessorKey: "creation_data",
    header: "Created By",
    type: "createdBy",
    headerTooltip:
      "The Created By value is only available for resources created within the last 90 days.",
  },
  {
    accessorKey: "created_at",
    header: "Launch time",
    type: "date",
  },
  {
    accessorKey: "nodes_count",
    header: "Total Nodes",
    type: "nodesCount",
  },
  { accessorKey: "instance_type", header: "Instance Type" },
  {
    accessorKey: "connections_value",
    header: "Connections",
    type: "statistic",
    headerTooltip: "The total number of connections for the last 7 days.",
  },
  { accessorKey: "region", header: "Region", type: "withCopy" },
  { accessorKey: "cache_type", header: "Database Type" },
  {
    accessorKey: "cpu_value",
    header: "CPU Max",
    type: "cpuStatistic",
    headerTooltip: "The maximum usage of CPU for the last 7 days.",
  },
  { accessorKey: "tags", header: "Tags", type: "tag", enableSorting: false },
  {
    accessorKey: "tags",
    header: "Smart Tags",
    id: "smart_tag",
    type: "smartTag",
    enableSorting: false,
  },
  {
    accessorKey: "issues",
    header: "Ticket Status",
    type: "jiraTicketStatus",
    enableSorting: false,
  },
];
